import React from "react";
import styles from "./RsvpDateTime.module.css";
import { Layout } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import Rsvp from "../../../../assets/rsvp2.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";

import { FaRegCalendarAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { CalendarIcon, LocIcon } from "../../../../components/icons/Icons";
import { useSelector } from "react-redux";
import moment from "moment";

const RsvpDateTime = () => {
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  const navigate = useNavigate();
  const myStyle = {
    backgroundImage: `url(${bgcImage})`,
    backgroundRepeat: "no-repeat",
  };
  return (
    <div style={myStyle} className={styles.mainContainer}>
      <Header
        mainHeader={styles.headerColor}
        isProfile={true}
        title={"RSVP"}
        onBackClick={() => navigate(-1)}
      />
      <div className={styles.mainDiv}>
        <div className={styles.innerDiv}>
          <div className={styles.innerDiv2}>
            <div className={styles.innerDiv3}>
              <div className={styles.innerMainContainer}>
                <div className={styles.innerRowContainer}>
                  {/* <FaRegCalendarAlt className={styles.icon} size={40} /> */}
                  <CalendarIcon size={35} />
                  <div className={styles.textContainer}>
                    <TextComponent
                      textClass={styles.textDay}
                      text={moment(rsvpData?.event?.date).format("dddd")}
                    />
                    <TextComponent
                      textClass={styles.textDate}
                      text={moment(rsvpData?.event?.date).format(
                        "MMM DD, yyyy"
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.innerMainContainer}>
                <div className={styles.innerRowContainer}>
                  {/* <FaLocationDot className={styles.icon} size={40} /> */}
                  <LocIcon size={35} />
                  <div className={styles.textContainer}>
                    <TextComponent
                      textClass={styles.text1}
                      text={
                        rsvpData?.event?.address.substring(0, 27) +
                        `${rsvpData?.event?.address?.length > 20 ? "..." : ""}`
                      }
                    />
                    {/* <TextComponent
                      textClass={styles.text1}
                      text={"California"}
                    /> */}
                  </div>
                </div>
              </div>
              <div
                className={styles.icon1}
                onClick={() => navigate("/rsvp/rsvpGuestStory")}
              >
                <BiSolidChevronRightCircle size={30} />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.imgContainer}>
          {rsvpData?.card.type == "card" ? (
            <img
              className={styles.innerImg}
              src={rsvpData?.card?.image ? rsvpData?.card?.image : Rsvp}
            />
          ) : (
            <TextComponent
              textClass={styles.text1}
              style={{ fontSize: "14px" }}
              text={rsvpData?.card?.message}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RsvpDateTime;
